export const TIMETYPE_FIXED = "Tiempo Fijo";
export const TIMETYPE_MAPS = "Google Maps";
